/**
 * An investor portal service's mark (#11635): its favicon, or the globe
 * glyph when it has none. The manager groups' headers carry it beside the
 * services that delivered their documents.
 */
import { GlobeIcon } from "@phosphor-icons/react";
import React from "react";
import { ServiceFavicon } from "@/components/common/ServiceFavicon";

export const ServiceMark: React.FC<{
  service: string;
  host: string | null;
  size?: number;
}> = ({ service, host, size = 16 }) => (
  <ServiceFavicon
    host={host}
    label={service}
    size={size}
    fallback={
      <GlobeIcon
        size={size}
        aria-hidden
        className="shrink-0 text-[var(--fp-ink-3)]"
      />
    }
  />
);
